import { render, staticRenderFns } from "./DraftsModule.vue?vue&type=template&id=627067d1&scoped=true"
import script from "./DraftsModule.vue?vue&type=script&lang=js"
export * from "./DraftsModule.vue?vue&type=script&lang=js"
import style0 from "./DraftsModule.vue?vue&type=style&index=0&id=627067d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627067d1",
  null
  
)

export default component.exports